import React from 'react'

const StatCard = ({totalAdminUsers}) => {  
  return (
    <div className="row">
        <div className="col-lg-3 col-12 mb-2">
          <div className="card">
            <div className="card-body p-3">
              <div className="d-flex align-items-center">
                <div className="badge rounded-pill bg-label-primary me-3 p-2">
                  <i className="ti ti-users ti-sm"></i>
                </div>
                <div className="card-info">
                  <h5 className="mb-0">{totalAdminUsers}</h5>
                  <small>Total Users</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default StatCard;